<!-- Mensagem se IES não estiver na lista -->
<ng-container *ngIf="!ies">
  <div class="alert alert-warning alert-custom">
    <p>Não permitido!</p>
  </div>
</ng-container>

<!-- Pesquisa por certificado -->
<ng-container *ngIf="ies && !certificado">
  <navbar></navbar>

  <section class="container-fluid" [ngClass]="{'estacioSubHeader': ies.codigo === 1}">
    <div class="container">
      <div class="row">

        <div class="col-lg-7">
          <div class="header">
            <div>
              <h1>Micro Certificações</h1>
              <p><br></p>
              <!--<p>Busca de Informações de Registro de Diplomas Em atendimento à Portaria MEC nº 1.095/2018, publicada no Diário Oficial da União em 26.10.2018, que dispõe sobre a expedição e o registro de diplomas de cursos superiores de graduação no âmbito do sistema federal de ensino, a {{ this.ies.name }} disponibiliza nesta página todos os Diplomas dos alunos que colaram grau a partir de 25.4.2019 para fins de verificação de autenticidade.</p>
              <p>Selecione o nome completo do aluno ou o número de registro do diploma.</p>-->
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <section class="container corpo">
    <div class="row">

      <div class="col-lg-4">
        <div class="card-blue-container">
          <div class="card-topo-consulta">
            <div class="row">
              <div class="col-12">
                <div class="content-card">
                  <div>
                    <img src="assets/images/cartao.png">
                  </div>
                  <p>
                    CERTIFICADO<br>
                    <small>Digite o código no campo abaixo.</small>
                  </p>
                </div>
              </div>
            </div>

            <form name="certificacaoForm" [formGroup]="certificacaoForm" (ngSubmit)="busca(certificacaoForm.controls['codigo'].value)" novalidate>
              <div class="inputs">
                <div class="spinner-border" role="status" *ngIf="isLoading">
                  <span class="sr-only"></span>
                </div>

                <input type="text" placeholder="Código" minlength="4" formControlName="codigo">

                <div class="captcha">
                  <input type="text" placeholder="AAAA" maxlength="4" formControlName="captcha">
                  <span>{{ captcha }}</span>
                </div>
              </div>

              <button type="submit" class="btn" [disabled]="(certificacaoForm.controls['codigo'].value.length < 5) || (certificacaoForm.controls['captcha'].value != captcha)">
                <i-bs name="arrow-right-short"></i-bs>
              </button>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-6 offset-md-2">
        <img src="assets/images/pesquisa.svg" class="img-fluid">
      </div>
    </div>
  </section>
</ng-container>

<!-- Certificado encontrado -->
<ng-container *ngIf="ies && certificado">
  <navbar></navbar>

  <section class="container-fluid" [ngClass]="{'estacioSubHeader': ies.codigo === 1}">
    <div class="container">
      <div class="header">
        <div class="row">

          <div class="col-lg-12">
            <div class="share">
              <div>
                <h1>Esse é o seu Certificado</h1>
              </div>

              <div>
                <p>compartilhe</p>
                <div>
                  <a [href]="'http://www.facebook.com/sharer/sharer.php?u=' + imagem | safeUrl" target="_blank" class="btn btn-facebook">Facebook</a>
                  <a [href]="'https://www.linkedin.com/sharing/share-offsite/?url=' + imagem | safeUrl" target="_blank" class="btn btn-linkedin">Linkedin</a>
                  <!--<button type="button" (click)="social('facebook')" class="btn btn-facebook">facebook</button>
                  <button type="button" (click)="social('linkedin')" class="btn btn-linkedin">linkedin</button>-->
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <section>
              <img [src]="imagem | safeUrl">
            </section>
          </div>

          <div class="col-lg-12">
            <div class="share">
              <button type="button" class="btn btn-pdf" (click)="exibirPDF()">Exibe PDF</button>
            </div>
            <br>
          </div>

          <ng-container *ngIf="exibePDF">
            <div class="col-lg-10" #Resultado>
              <div class="ratio ratio-16x9">
                <object [data]="pdf + '#toolbar=1&navpanes=0' | safeUrl" type="application/pdf" class="pdf-view"></object>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
</ng-container>
